export default {

    setAll: function(logLevel) {
        return $.ajax({
            url: context.path + "/webservices/rest/log/" + logLevel,
            type: "POST",
            contentType: "application/json"
        });
    },

    clearLogFile: function(nodeIdentifier) {
        return $.ajax({
            url: `${context.path}/webservices/rest/log/clear/node`,
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({nodeIdentifier})
        });
    },

    clearLogFiles() {
        return $.ajax({
            url: `${context.path}/webservices/rest/log/clear`,
            type: "POST"
        });
    },

    /**
     * Log an error
     * @param message {string} The message to log
     * @param stack {Array} The stack trace to log
     * @param [localErrors] {boolean} Whether to suppress errors from this call; default false
     */
    logError: function(message, stack, localErrors = false) {
        return $.ajax({
            localErrors: localErrors,
            url: context.path + "/webservices/rest/log/ui",
            type: "PUT",
            contentType: "application/json",
            data: JSON.stringify({
                message: message,
                details: stack
            })
        });
    },

    /**
     * Get the log.
     * @param nodeIdentifier
     */
    getLog(nodeIdentifier) {
        return $.ajax({
            url: `${context.path}/webservices/rest/log/viewer/file`,
            method: "GET",
            data: {
                nodeIdentifier
            }
        });
    },

    /**
     * Get the dates that have log files
     * @param nodeIdentifier
     * @returns {Promise} Array of days logs are available represented as yyyy-MM-dd
     */
    getLogDates(nodeIdentifier) {
        return $.ajax({
            url: `${context.path}/webservices/rest/log/viewer/file/dates`,
            method: "GET",
            data: {
                nodeIdentifier
            }
        });
    }
};
